import App from './App.vue'
import Vue from 'vue'

const mount = document.querySelector('#cookie-banner')

// Create a Vue instance only if the cookie banner mount element is present
// and the bypass query parameter is not 0.
if (mount) {
  new Vue({ render: h => h(App) }).$mount(mount)
}
